import ImportIcon from '@material-ui/icons/ImportExport';

import OrderImportTracksList from './List/List';

export const orderImportTracksResource = {
	list: OrderImportTracksList,
	icon: ImportIcon,
};
